import { ReactComponent as VenueIcon } from '@/assets/icons/ri-map-pin-2-fill.svg'
import { ReactComponent as CourtIcon } from '@/assets/icons/ri-badminton-court.svg';
import { getLongDateFormat, groupBookingHours } from '@/utils';



const dateVenueKey = (date: number, venueName: string) => `${date}_${venueName}`;

const venues = {};
const courts = {};


const groupDataByDateCourt = (schedules: ClubSchedule[]) => {
	const bookedCourts = {};
	schedules.forEach((schedule: ClubSchedule) => {
		venues[schedule.venue_id] = schedule.venue_name;
		courts[schedule.venue_court_id] = schedule.venue_court_code;
		const key = dateVenueKey(schedule.date, schedule.venue_id);
		if (bookedCourts[key]) {
			if (bookedCourts[key][schedule.venue_court_id]) {
				bookedCourts[key][schedule.venue_court_id].push(schedule)
			} else {
			  	bookedCourts[key][schedule.venue_court_id] = [schedule];
			}
			
		} else {
			const venueSchedule = {}
			venueSchedule[schedule.venue_court_id] = [schedule]
			bookedCourts[key] = venueSchedule;
		}
	});
	return bookedCourts;
};


const LeftSection = ({ name, desc, schedules }: ClubLeftSectionProps) => {
	const groupSchedules = groupDataByDateCourt(schedules);
	return (
		<div>
			<div className="card text-jb-3xl p-7">
				{name}
			</div>
			<div className="mt-7 card p-7 flex flex-col">
				<div className="text-jb font-bold pb-4">Description</div>
				<div>{desc}</div>
			</div>
			<div className="mt-7 card">
				<div className="text-jb font-bold p-7 border-b border-grey-line-subtle">Schedules</div>
				<div className="p-7">
					{Object.keys(groupSchedules).map((keyDateVenueID) => {
						const dateVenuIDArr = keyDateVenueID.split("_", 2);
						let dateStr = "";
						let venueID = "";
						if (dateVenuIDArr.length >= 2) {
							[dateStr, venueID] = dateVenuIDArr
						}
						const courtSchedules = groupSchedules[keyDateVenueID];
						return (
							<div className="border border-grey-line-subtle rounded mb-4">
								<div className="flex flex-row border-b border-grey-line-subtle p-4 justify-between">
									<div>
										{getLongDateFormat(Number(dateStr))}
									</div>
									<div className='flex flex-row items-center'>
										<VenueIcon className="text-red-primary"/>
										<p className="font-medium text-sm ml-2">{venues[venueID]}</p>
									</div>
								</div>
								{Object.keys(courtSchedules).map((keyCourtID, idx) => {
									const courtName = courts[keyCourtID];
									const scheduleItems = courtSchedules[keyCourtID];
									const hours = groupBookingHours(
										scheduleItems.map((item) => item.start_time)
									);
									return (
										<div className={`flex flex-row p-4 justify-between ${  idx > 0 ? 'border-t border-grey-line-subtle' : ''}`}>
											<div className="flex flex-row">
												<div className="justify-center items-center px-2 py-2 h-10 gap-2 bg-green-success rounded text-white">
													<CourtIcon/>
												</div>	
												<p className='text-sm ml-2 font-medium' key={keyCourtID}>{courtName}</p>
											</div>
											<div className='flex flex-col'>
												{Object.values(hours).map((hour) => {
													const { start, end } = hour;
													return (
														<p className="text-sm text-grey-dark text-right">
															{`${start}.00 - ${end}.00 WITA`}
														</p>
													);
												})}
											</div>
										</div>
									);
									}
								)}
							</div>
						);
					})
					}
				</div>
			</div>
		</div>
	);
};


export default LeftSection;
